import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from '@app/shared';
import { DocRendererModule } from '@app/renderer';
import { SettingRoutingModule, COMPONENTS } from './setting-routing.module';
import { SettingComponent } from './setting.component';
import { EditorModule, TINYMCE_SCRIPT_SRC } from '@tinymce/tinymce-angular';
import {
  FieldModalComponent,
  FieldSelectionModalComponent,
  AppConfigNewModalComponent,
  MessageNewModalComponent,
  DocumentGroupNewModalComponent,
  UserNewModalComponent,
  LookupDataModalComponent,
  LookupTypeModalComponent,
  RoleNewModalComponent,
  CompanyProfileModalComponent,
  MyProfileModalComponent,
  ApplicationDetailModalComponent,
  ApplicationNewModalComponent,
  OrganizationTypeDetailModalComponent,
  OrganizationTypeModalComponent,
  // workflow
  WorkflowGroupAddModalComponent,
  WorkflowNewModalComponent,
  WorkflowGroupModalComponent,
  //Userchange
  UsernameChangeModalComponent,
  FAQModalComponent,
  UpdateWorkflowGroupComponent,
  NewWorkflowComponent,
  AssignUsersModalComponent,
  AddNewWorkflowGroupComponent,
  AssignDocumentTypeModalComponent,
  AvaliableChangeModalComponent,
} from './modals';
import { CompanyAffiliateTypesComponent } from './components/company-affiliate-types/company-affiliate-types.component';
import { AffiliateTypeListComponent } from './components/company-affiliate-types/affiliate-type-list/affiliate-type-list.component';
import { AffiliateTypeModalComponent } from './modals/affiliate-type-modal/affiliate-type-modal.component';
import { FinancialEndModalComponent } from './modals/new-financial-end/new-financial-end-modal.component';
import { CompanyDataManagementComponent } from './components';
import { ChatConfigurationComponent } from './components/chat-configuration/chat-configuration.component';
import { ChatTopicComponent } from './components/chat-configuration/chat-topic/chat-topic.component';
import { ChatSubtopicComponent } from './components/chat-configuration/chat-subtopic/chat-subtopic.component';
import { AddTopicModalComponent } from './modals/add-topic-modal/add-topic-modal.component';
import { AddSubtopicModalComponent } from './modals/add-subtopic-modal/add-subtopic-modal.component';
import { EditSubtopicModalComponent } from './modals/edit-subtopic-modal/edit-subtopic-modal.component';
import { EditTopicModalComponent } from './modals/edit-topic-modal/edit-topic-modal.component';
import { AssignSubtopicModalComponent } from './modals/assign-subtopic-modal/assign-subtopic-modal.component';
import { ViewDetailsModalComponent } from './modals/view-details-modal/view-details-modal.component';
import { ApplicationSecurityComponent } from './components/application-security/application-security.component';
import { SecurityDashboardComponent } from './components/application-security/security-dashboard/security-dashboard.component';
import { SecurityIpManagementComponent } from './components/application-security/security-ip-management/security-ip-management.component';
import { SecurityFileUploadManagementComponent } from './components/application-security/security-file-upload-management/security-file-upload-management.component';
import { SecurityHomeComponent } from './components/application-security/security-home/security-home.component';
import { DashboardGraphComponent } from './components/application-security/security-dashboard/dashboard-graph/dashboard-graph.component';
import { EventLogComponent } from './components/application-security/security-dashboard/event-log/event-log.component';
import { AlertManagementComponent } from './components/application-security/alerts/alerts.component';
import { AlertManagementDashboardComponent } from './components/application-security/alerts/alert-dashboard/alert-dashboard.component';
import { AlertNotificationsComponent } from './components/application-security/alerts/alert-notifications/alert-notifications.component';
import { AlertScenariosComponent } from './components/application-security/alerts/alert-scenarios/alert-scenarios.component';
import { AlertScenariosRowComponent } from './components/application-security/alerts/alert-scenarios/alert-scenarios-row/alert-scenarios-row.component';
import { AlertNotificationRowComponent } from './components/application-security/alerts/alert-notifications/alert-notifications-row/alert-notifications-row.component';

import { UserManagementComponent } from './components/application-security/user-management/user-management.component';
import { AllUsersComponent } from './components/application-security/user-management/all-users/all-users.component';
import { RecentlyLoggedInUsersComponent } from './components/application-security/user-management/recently-logged-in-users/recently-logged-in-users.component';
import { BlockedUsersComponent } from './components/application-security/user-management/blocked-users/blocked-users.component';
import { ViewUserActivityModalComponent } from './components/application-security/modals/view-user-activity-modal/view-user-activity-modal.component';
import { GeofencingManagementComponent } from './components/application-security/geofencing-management/geofencing-management.component';
import { GeofenceDashboardComponent } from './components/application-security/geofencing-management/geofence-dashboard/geofence-dashboard.component';
import { GeofenceLogsComponent } from './components/application-security/geofencing-management/geofence-logs/geofence-logs.component';
import { GeofenceUserProfileSettingsComponent } from './components/application-security/geofencing-management/geofence-user-profile-settings/geofence-user-profile-settings.component';
import { GlobalGeofenceSettingsComponent } from './components/application-security/geofencing-management/global-geofence-settings/global-geofence-settings.component';
import { GeofenceUserComponent } from './components/application-security/geofencing-management/geofence-user/geofence-user.component';
import { EventLogRowComponent } from './components/application-security/security-dashboard/event-log/event-log-row/event-log-row.component';
import { CreateAlertModalComponent } from './modals/app-security-modals/create-alert-modal/create-alert-modal.component';
import { SecurityConfirmationModalComponent } from './modals/app-security-modals/security-confirmation-modal/security-confirmation-modal.component';
import { NgxEchartsModule } from 'ngx-echarts';
import * as echarts from 'echarts';
import { IpManagementRowComponent } from './components/application-security/security-ip-management/ip-management-row/ip-management-row.component';
import { BlockIpAddressModalComponent } from './modals/app-security-modals/block-ip-address-modal/block-ip-address-modal.component';
import { IpAddressConfigurationModalComponent } from './modals/app-security-modals/ip-address-configuration-modal/ip-address-configuration-modal.component';
import { EditFileSizeModalComponent } from './modals/app-security-modals/edit-file-size-modal/edit-file-size-modal.component';
import { FileUploadLimitModalComponent } from './modals/app-security-modals/file-upload-limit-modal/file-upload-limit-modal.component';
import { FileLogsComponent } from './components/application-security/security-file-upload-management/file-logs/file-logs.component';
import { FileLogRowComponent } from './components/application-security/security-file-upload-management/file-logs/file-log-row/file-log-row.component';
import { FileUploadSettingsComponent } from './components/application-security/security-file-upload-management/file-upload-settings/file-upload-settings.component';
import { FileUploadSettingRowComponent } from './components/application-security/security-file-upload-management/file-upload-settings/file-upload-setting-row/file-upload-setting-row.component';
import { FileUploadDashboardComponent } from './components/application-security/security-file-upload-management/file-upload-dashboard/file-upload-dashboard.component';
// import { FileSettingComponent } from './components/application-security/security-file-upload-management/file-upload-settings/file-setting/file-setting.component';
import { EditAlertNotificationComponent } from './components/application-security/modals/edit-alert-notification-modal/edit-alert-notification-modal.component';
import { DeleteAlertNotificationModalComponent } from './components/application-security/modals/delete-alert-notification/delete-alert-notification.component';
import { ViewAlertModalComponent } from './modals/app-security-modals/view-alert-modal/view-alert-modal.component';
import { DeleteAlertModalComponent } from './modals/app-security-modals/delete-alert-modal/delete-alert-modal.component';
import { ApplicationSecurityLogsComponent } from './components/application-security/logs/logs.component';
import { LogsRowComponent } from './components/application-security/logs/logs-row/logs-row.component';
import { WhiteListOrBlackListIpModalComponent } from './modals/app-security-modals/whitelistOrBlackListIpAddress/whitelistOrBlackListIpAddress.component';
import { RateLimitComponent } from './components/application-security/rate-limit/rate-limit.component';
import { RateLimitDashboardComponent } from './components/application-security/rate-limit/dashboard/rate-limit-dashboard.component';
import { RateLimitLogsComponent } from './components/application-security/rate-limit/rate-limit-logs/rate-limit-logs.component';
import { RateLimitProfileSettingsComponent } from './components/application-security/rate-limit/rate-limit-profile-settings/rate-limit-profile-settings.component';
import { GlobalRateLimitSettings } from './components/application-security/rate-limit/global-rate-limit-settings/global-rate-limit-settings.component';
import { UsersRateLimitProfileComponent } from './components/application-security/rate-limit/users-with-rate-limit-profile/users-with-rate-limit-profile.component';

import { AllowedCountriesComponent } from './components/application-security/geofencing-management/global-geofence-settings/allowed-countries/allowed-countries.component';
import { DisallowedCompaniesComponent } from './components/application-security/geofencing-management/global-geofence-settings/disallowed-companies/disallowed-companies.component';
import { AssignGeofenceProfileComponent } from './components/application-security/modals/assign-geofence-profile/assign-geofence-profile.component';
import { AssignRateLimitModalComponent } from './components/application-security/modals/assign-rate-limit-modal/assign-rate-limit-modal.component';
import { DynamicHeaderComponent } from './components/application-security/dynamic-header/dynamic-header.component';
import { SettingsHomeComponent } from './components/application-security/settings-home/settings-home.component';
import { SettingsListComponent } from './components/application-security/settings-home/settings-list/settings-list.component';
import { EditGeofenceModalComponent } from './components/application-security/modals/edit-geofence-modal/edit-geofence-modal.component';
import { ViewGeofenceProfileComponent } from './components/application-security/modals/view-geofence-profile/view-geofence-profile.component';
import { AddCountryModalComponent } from './components/application-security/modals/add-country-modal/add-country-modal.component';
import { ViewProfileModalComponent } from './components/application-security/modals/view-profile-modal/view-profile-modal.component';
import { EditDynamicHeaderComponent } from './components/application-security/modals/edit-dynamic-header/edit-dynamic-header.component';
import { AddNotificationModalComponent } from './components/application-security/modals/add-notification-modal/add-notification-modal.component';
import { EditRateLimitProfileComponent } from './components/application-security/modals/edit-rate-limit-profile/edit-rate-limit-profile.component';
import { FileSettingComponent } from './components/application-security/security-file-upload-management/file-upload-settings/file-upload-setting-row/file-setting/file-setting.component';
import { ViewRateLimitProfileComponent } from './components/application-security/modals/viewRateLimitProfile/viewRateLimitProfile.component';
import { AddGlobalRateLimitModalComponent } from './components/application-security/modals/add-global-ratelimit/add-global-ratelimit.component';
import { DeleteGlobalRateLimitProfileModalComponent } from './components/application-security/modals/delete-global-ratelimit-profile/delete-global-ratelimit-profile.component';
import { AddRateLimitProfileModalComponent } from './components/application-security/modals/add-rate-limit-profile-settings/add-rate-limit-profile-settings.component';

const ENTRY_COMPONENTS: Array<any> = [
  FieldModalComponent,
  FieldSelectionModalComponent,
  AppConfigNewModalComponent,
  MessageNewModalComponent,
  DocumentGroupNewModalComponent,
  UserNewModalComponent,
  LookupDataModalComponent,
  LookupTypeModalComponent,
  RoleNewModalComponent,
  CompanyProfileModalComponent,
  MyProfileModalComponent,
  ApplicationDetailModalComponent,
  ApplicationNewModalComponent,
  OrganizationTypeDetailModalComponent,
  OrganizationTypeModalComponent,
  WorkflowGroupAddModalComponent,
  WorkflowNewModalComponent,
  WorkflowGroupModalComponent,
  UsernameChangeModalComponent,
  FAQModalComponent,
  UpdateWorkflowGroupComponent,
  NewWorkflowComponent,
  AssignUsersModalComponent,
  AddNewWorkflowGroupComponent,
  FinancialEndModalComponent,
  AssignDocumentTypeModalComponent,
  AvaliableChangeModalComponent,
  AddTopicModalComponent,
  AddSubtopicModalComponent,
  ViewDetailsModalComponent,
  EditTopicModalComponent,
  EditSubtopicModalComponent,
  AssignSubtopicModalComponent,
];
@NgModule({
  declarations: [
    SettingComponent,
    ...COMPONENTS,
    ...ENTRY_COMPONENTS,
    CompanyAffiliateTypesComponent,
    AffiliateTypeListComponent,
    AffiliateTypeModalComponent,
    CompanyDataManagementComponent,
    ChatConfigurationComponent,
    ChatTopicComponent,
    ChatSubtopicComponent,
    AddTopicModalComponent,
    AddSubtopicModalComponent,
    EditSubtopicModalComponent,
    EditTopicModalComponent,
    AssignSubtopicModalComponent,
    ViewDetailsModalComponent,
    ApplicationSecurityComponent,
    SecurityDashboardComponent,
    SecurityIpManagementComponent,
    SecurityFileUploadManagementComponent,
    SecurityHomeComponent,
    DashboardGraphComponent,
    EventLogComponent,
    AlertManagementComponent,
    AlertManagementDashboardComponent,
    AlertScenariosComponent,
    AlertNotificationsComponent,
    AlertScenariosRowComponent,
    AlertNotificationRowComponent,
    UserManagementComponent,
    AllUsersComponent,
    BlockedUsersComponent,
    RecentlyLoggedInUsersComponent,
    ViewUserActivityModalComponent,
    GeofencingManagementComponent,
    GeofenceDashboardComponent,
    GeofenceLogsComponent,
    GeofenceUserProfileSettingsComponent,
    GlobalGeofenceSettingsComponent,
    GeofenceUserComponent,
    GeofencingManagementComponent,
    GeofenceDashboardComponent,
    GeofenceLogsComponent,
    GeofenceUserProfileSettingsComponent,
    GlobalGeofenceSettingsComponent,
    GeofenceUserComponent,
    EventLogRowComponent,
    CreateAlertModalComponent,
    SecurityConfirmationModalComponent,
    IpManagementRowComponent,
    BlockIpAddressModalComponent,
    IpAddressConfigurationModalComponent,
    EditFileSizeModalComponent,
    FileUploadLimitModalComponent,
    FileLogsComponent,
    FileLogRowComponent,
    FileUploadSettingsComponent,
    FileUploadSettingRowComponent,
    FileUploadDashboardComponent,
    FileSettingComponent,
    EditAlertNotificationComponent,
    DeleteAlertNotificationModalComponent,
    ViewAlertModalComponent,
    DeleteAlertModalComponent,
    ApplicationSecurityLogsComponent,
    LogsRowComponent,
    WhiteListOrBlackListIpModalComponent,
    AllowedCountriesComponent,
    DisallowedCompaniesComponent,
    AssignGeofenceProfileComponent,
    AssignRateLimitModalComponent,
    DynamicHeaderComponent,
    SettingsHomeComponent,
    SettingsListComponent,
    EditGeofenceModalComponent,
    ViewGeofenceProfileComponent,
    RateLimitComponent,
    RateLimitDashboardComponent,
    RateLimitLogsComponent,
    RateLimitProfileSettingsComponent,
    GlobalRateLimitSettings,
    UsersRateLimitProfileComponent,
    AddCountryModalComponent,
    ViewProfileModalComponent,
    EditDynamicHeaderComponent,
    AddNotificationModalComponent,
    EditRateLimitProfileComponent,
    ViewRateLimitProfileComponent,
    AddGlobalRateLimitModalComponent,
    DeleteGlobalRateLimitProfileModalComponent,
    AddRateLimitProfileModalComponent,
  ],
  imports: [
    CommonModule,
    SharedModule,
    SettingRoutingModule,
    EditorModule,
    DocRendererModule,
    NgxEchartsModule.forRoot({ echarts }),
  ],
  entryComponents: [...ENTRY_COMPONENTS],
  providers: [
    { provide: TINYMCE_SCRIPT_SRC, useValue: 'tinymce/tinymce.min.js' },
  ],
})
export class SettingModule {}
